cityPipeLength={
    "北京": 28242.96,
    "天津": 18557.23,
    "河北": 19653.71,
    "石家庄市": 2641.95,
    "晋州市": 100.37,
    "新乐市": 200.0,
    "唐山市": 2388.27,
    "滦州市": 333.67,
    "遵化市": 162.5,
    "迁安市": 533.5,
    "秦皇岛市": 1246.6,
    "邯郸市": 1602.02,
    "武安市": 566.3,
    "邢台市": 1072.32,
    "南宫市": 117.0,
    "沙河市": 213.35,
    "保定市": 1413.06,
    "涿州市": 264.76,
    "安国市": 118.0,
    "高碑店市": 315.32,
    "白沟新城": 242.0,
    "张家口市": 833.49,
    "承德市": 693.23,
    "平泉市": 114.5,
    "沧州市": 507.4,
    "泊头市": 300.5,
    "任丘市": 651.57,
    "黄骅市": 568.0,
    "河间市": 326.5,
    "廊坊市": 504.94,
    "霸州市": 282.52,
    "三河市": 342.62,
    "衡水市": 430.99,
    "深州市": 196.2,
    "辛集市": 142.46,
    "定州市": 227.8,
    "山西": 11010.05,
    "太原市": 2426.75,
    "古交市": 156.56,
    "大同市": 903.0,
    "阳泉市": 1149.02,
    "长治市": 1200.51,
    "潞城市": 83.8,
    "晋城市": 635.95,
    "高平市": 198.0,
    "朔州市": 346.95,
    "晋中市": 463.42,
    "介休市": 130.24,
    "运城市": 679.87,
    "永济市": 90.0,
    "河津市": 152.0,
    "忻州市": 516.13,
    "原平市": 207.71,
    "临汾市": 555.64,
    "侯马市": 171.0,
    "霍州市": 240.0,
    "吕梁市": 266.4,
    "孝义市": 259.0,
    "汾阳市": 178.1,
    "内蒙古": 10069.4,
    "呼和浩特市": 980.73,
    "包头市": 1839.0,
    "乌海市": 646.0,
    "赤峰市": 981.57,
    "通辽市": 327.14,
    "霍林郭勒市": 375.0,
    "鄂尔多斯市": 1401.81,
    "呼伦贝尔市": 419.23,
    "满洲里市": 472.85,
    "牙克石": 145.5,
    "扎兰屯市": 121.62,
    "额尔古纳市": 82.0,
    "根河市": 33.95,
    "巴彦淖尔市": 358.38,
    "乌兰察布市": 318.0,
    "丰镇市": 224.02,
    "乌兰浩特市": 297.0,
    "阿尔山市": 76.8,
    "二连浩特": 429.0,
    "锡林浩特市": 539.8,
    "辽宁": 37099.01,
    "沈阳市": 5109.37,
    "新民市": 244.0,
    "大连市": 6389.4,
    "瓦房店市": 532.6,
    "庄河市": 441.4,
    "鞍山市": 2822.51,
    "海城市": 470.0,
    "抚顺市": 2435.7,
    "本溪市": 1059.26,
    "丹东市": 876.08,
    "东港市": 315.9,
    "凤城市": 585.03,
    "锦州市": 1690.0,
    "凌海市": 168.0,
    "北镇市": 124.28,
    "营口市": 2928.0,
    "盖州市": 268.28,
    "大石桥市": 1369.3,
    "阜新市": 1911.1,
    "辽阳市": 978.61,
    "灯塔市": 200.71,
    "盘锦市": 1812.5,
    "铁岭市": 965.48,
    "调兵山市": 538.04,
    "开原市": 200.28,
    "朝阳市": 672.4,
    "北票市": 344.3,
    "凌源市": 560.0,
    "葫芦岛市": 701.48,
    "兴城市": 385.0,
    "吉林": 13125.58,
    "长春市": 3123.23,
    "榆树市": 211.99,
    "德惠市": 591.55,
    "吉林市": 1347.41,
    "蛟河市": 469.59,
    "桦甸市": 145.0,
    "舒兰市": 111.86,
    "磐石市": 153.3,
    "四平市": 1246.36,
    "双辽市": 96.05,
    "辽源市": 515.88,
    "通化市": 647.97,
    "集安市": 137.02,
    "白山市": 369.91,
    "临江市": 185.32,
    "松原市": 414.3,
    "扶余市": 51.2,
    "白城市": 458.0,
    "洮南市": 106.0,
    "大安市": 114.2,
    "延吉市": 515.28,
    "图们市": 130.83,
    "敦化市": 247.51,
    "珲春市": 169.09,
    "龙井市": 128.79,
    "和龙市": 191.55,
    "公主岭市": 314.81,
    "梅河口市": 370.0,
    "长白山保护开发区管理委员会": 561.58,
    "黑龙江": 16070.02,
    "哈尔滨市": 2376.99,
    "尚志市": 207.72,
    "五常市": 203.0,
    "齐齐哈尔市": 1212.38,
    "讷河市": 102.3,
    "鸡西市": 802.38,
    "虎林市": 199.78,
    "密山市": 138.1,
    "鹤岗市": 624.21,
    "双鸭山市": 1133.01,
    "大庆市": 2943.88,
    "伊春市": 1275.93,
    "铁力市": 269.7,
    "佳木斯市": 637.17,
    "同江市": 285.0,
    "富锦市": 93.32,
    "抚远市": 59.5,
    "七台河市": 860.14,
    "牡丹江市": 599.0,
    "海林市": 90.4,
    "宁安市": 153.94,
    "穆棱市": 143.87,
    "绥芬河市": 182.41,
    "东宁市": 103.73,
    "黑河市": 193.46,
    "北安市": 139.45,
    "五大连池市": 110.0,
    "绥化市": 405.3,
    "安达市": 91.5,
    "肇东市": 149.85,
    "海伦市": 282.6,
    "上海": 38413.68,
    "江苏": 101960.92,
    "南京市": 13638.55,
    "无锡市": 6004.0,
    "江阴市": 2271.4,
    "宜兴市": 2192.8,
    "徐州市": 3134.88,
    "新沂市": 800.0,
    "邳州市": 588.95,
    "常州市": 18456.94,
    "溧阳市": 878.72,
    "苏州市": 9409.72,
    "常熟市": 2975.5,
    "张家港市": 1009.0,
    "昆山市": 3280.7,
    "太仓市": 388.59,
    "南通市": 3610.76,
    "海安市": 2163.41,
    "启东市": 843.3,
    "如皋市": 1099.73,
    "海门市": 1275.67,
    "连云港市": 2671.33,
    "淮安市": 4355.92,
    "盐城市": 3646.28,
    "东台市": 1104.59,
    "扬州市": 3802.87,
    "仪征市": 1043.14,
    "高邮市": 494.62,
    "镇江市": 2672.15,
    "丹阳市": 550.0,
    "扬中市": 526.56,
    "句容市": 602.75,
    "泰州市": 2452.21,
    "兴化市": 553.25,
    "靖江市": 886.0,
    "泰兴市": 557.68,
    "宿迁市": 2018.95,
    "浙江": 72917.08,
    "杭州市": 13837.18,
    "建德市": 696.93,
    "宁波市": 10826.72,
    "余姚市": 2008.66,
    "慈溪市": 1799.35,
    "温州市": 3322.28,
    "瑞安市": 1328.54,
    "乐清市": 738.35,
    "嘉兴市": 1002.9,
    "海宁市": 1267.93,
    "平湖市": 408.08,
    "桐乡市": 1249.08,
    "湖州市": 3840.17,
    "绍兴市": 7930.76,
    "诸暨市": 2349.19,
    "嵊州市": 1552.89,
    "金华市": 1816.8,
    "兰溪市": 1209.0,
    "义乌市": 2124.67,
    "东阳市": 1583.42,
    "永康市": 1320.89,
    "衢州市": 1161.23,
    "江山市": 530.21,
    "舟山市": 2181.0,
    "台州市": 3731.17,
    "玉环市": 423.0,
    "温岭市": 362.0,
    "临海市": 925.0,
    "丽水市": 1019.0,
    "龙泉市": 370.68,
    "安徽": 29392.0,
    "合肥市": 5876.1,
    "巢湖市": 621.0,
    "芜湖市": 1905.0,
    "蚌埠市": 1627.25,
    "淮南市": 1766.68,
    "马鞍山市": 2010.29,
    "淮北市": 1116.0,
    "铜陵市": 1634.45,
    "安庆市": 1157.59,
    "潜山市": 340.6,
    "桐城市": 239.61,
    "黄山市": 921.49,
    "滁州市": 1041.5,
    "天长市": 457.68,
    "明光市": 666.46,
    "阜阳市": 1744.34,
    "界首市": 247.69,
    "宿州市": 856.36,
    "六安市": 633.3,
    "亳州市": 1193.45,
    "池州市": 703.35,
    "宣城市": 2361.71,
    "宁国市": 270.1,
    "福建": 26886.49,
    "福州市": 5782.39,
    "福清市": 3124.21,
    "厦门市": 4234.34,
    "莆田市": 1659.18,
    "三明市": 556.61,
    "永安市": 388.95,
    "泉州市": 3337.97,
    "石狮市": 1035.58,
    "晋江市": 665.0,
    "南安市": 326.08,
    "漳州市": 1114.05,
    "龙海市": 382.85,
    "南平市": 588.76,
    "邵武市": 246.97,
    "武夷山市": 306.66,
    "建瓯市": 105.1,
    "龙岩市": 2192.83,
    "漳平市": 134.91,
    "宁德市": 336.35,
    "福安市": 145.87,
    "福鼎市": 221.83,
    "江西": 22075.94,
    "南昌市": 5110.23,
    "景德镇市": 936.14,
    "乐平市": 344.08,
    "萍乡市": 620.0,
    "九江市": 2527.9,
    "瑞昌市": 268.62,
    "共青城市": 216.2,
    "庐山市": 105.0,
    "新余市": 1009.5,
    "鹰潭市": 369.2,
    "贵溪市": 259.0,
    "赣州市": 3285.62,
    "瑞金市": 315.0,
    "吉安市": 1049.0,
    "井冈山市": 67.48,
    "宜春市": 1174.18,
    "丰城市": 622.46,
    "樟树市": 210.4,
    "高安市": 256.65,
    "抚州市": 981.5,
    "上饶市": 942.52,
    "德兴市": 1405.26,
    "山东": 54628.83,
    "济南市": 4436.61,
    "青岛市": 7531.21,
    "胶州市": 453.72,
    "平度市": 619.0,
    "莱西市": 548.75,
    "淄博市": 3156.16,
    "枣庄市": 1533.33,
    "滕州市": 1082.0,
    "东营市": 1948.56,
    "烟台市": 3666.93,
    "龙口市": 388.0,
    "莱阳市": 352.31,
    "莱州市": 737.07,
    "蓬莱市": 346.57,
    "招远市": 509.0,
    "栖霞市": 142.6,
    "海阳市": 445.0,
    "潍坊市": 2301.62,
    "青州市": 800.66,
    "诸城市": 367.81,
    "寿光市": 328.0,
    "安丘市": 478.78,
    "高密市": 315.1,
    "昌邑市": 117.46,
    "济宁市": 1630.02,
    "曲阜市": 352.55,
    "邹城市": 465.7,
    "泰安市": 2884.53,
    "新泰市": 828.8,
    "肥城市": 228.11,
    "威海市": 2808.6,
    "荣成市": 1030.86,
    "乳山市": 598.21,
    "日照市": 1751.0,
    "莱芜市": 531.14,
    "临沂市": 2654.35,
    "德州市": 1574.13,
    "乐陵市": 111.8,
    "禹城市": 326.77,
    "聊城市": 1452.33,
    "临清市": 300.3,
    "滨州市": 1742.77,
    "邹平市": 146.18,
    "菏泽市": 604.43,
    "河南": 25738.32,
    "郑州市": 4835.84,
    "巩义市": 185.16,
    "荥阳市": 339.1,
    "新密市": 273.0,
    "新郑市": 405.6,
    "登封市": 141.6,
    "开封市": 1761.07,
    "洛阳市": 1821.6,
    "偃师市": 207.8,
    "平顶山市": 1216.65,
    "舞钢市": 147.05,
    "汝州市": 337.63,
    "安阳市": 860.41,
    "林州市": 281.27,
    "鹤壁市": 594.32,
    "新乡市": 902.94,
    "卫辉市": 188.7,
    "辉县市": 432.86,
    "焦作市": 1133.26,
    "沁阳市": 191.1,
    "孟州市": 236.18,
    "濮阳市": 482.47,
    "许昌市": 758.57,
    "禹州市": 345.6,
    "长葛市": 148.0,
    "漯河市": 616.0,
    "三门峡市": 314.34,
    "义马市": 156.0,
    "灵宝市": 163.1,
    "南阳市": 1450.2,
    "邓州市": 669.8,
    "商丘市": 627.3,
    "永城市": 343.4,
    "信阳市": 1299.21,
    "周口市": 379.07,
    "项城市": 381.6,
    "驻马店市": 567.27,
    "济源市": 543.25,
    "湖北": 35076.28,
    "武汉市": 12554.44,
    "黄石市": 915.25,
    "大冶市": 243.52,
    "十堰市": 854.75,
    "丹江口市": 402.95,
    "宜昌市": 2312.42,
    "宜都市": 419.26,
    "当阳市": 668.29,
    "枝江市": 269.05,
    "襄阳市": 1054.17,
    "老河口市": 310.8,
    "枣阳市": 282.08,
    "宜城市": 252.68,
    "鄂州市": 1105.0,
    "荆门市": 598.0,
    "钟祥市": 275.38,
    "孝感市": 587.68,
    "应城市": 249.97,
    "安陆市": 223.8,
    "汉川市": 296.9,
    "荆州市": 1861.83,
    "石首市": 167.74,
    "洪湖市": 754.5,
    "松滋市": 344.1,
    "黄冈市": 451.0,
    "麻城市": 460.45,
    "武穴市": 490.0,
    "咸宁市": 695.17,
    "赤壁市": 382.24,
    "随州市": 986.0,
    "广水市": 471.4,
    "恩施市": 1247.84,
    "利川市": 339.62,
    "仙桃市": 705.65,
    "潜江市": 968.9,
    "天门市": 873.45,
    "湖南": 29808.63,
    "长沙市": 5721.0,
    "宁乡市": 1500.0,
    "浏阳市": 390.2,
    "株洲市": 3205.78,
    "醴陵市": 790.67,
    "湘潭市": 1339.74,
    "湘乡市": 725.0,
    "韶山市": 353.0,
    "衡阳市": 1387.51,
    "耒阳市": 226.1,
    "常宁市": 229.8,
    "邵阳市": 947.0,
    "武冈市": 444.66,
    "岳阳市": 1511.25,
    "汨罗市": 348.95,
    "临湘市": 208.27,
    "常德市": 2077.42,
    "津市市": 329.5,
    "张家界市": 586.5,
    "益阳市": 608.15,
    "沅江市": 183.6,
    "郴州市": 12.82,
    "资兴市": 483.0,
    "永州市": 1363.0,
    "怀化市": 1051.6,
    "洪江市": 253.76,
    "娄底市": 710.0,
    "冷水江市": 1802.75,
    "涟源市": 334.0,
    "吉首市": 683.6,
    "广东": 121089.51,
    "广州市": 35539.96,
    "韶关市": 2146.1,
    "乐昌市": 213.72,
    "南雄市": 116.27,
    "深圳市": 16838.0,
    "珠海市": 3926.2,
    "汕头市": 4783.89,
    "佛山市": 5614.6,
    "江门市": 3078.59,
    "台山市": 984.66,
    "开平市": 821.32,
    "鹤山市": 474.25,
    "恩平市": 2155.33,
    "湛江市": 1574.32,
    "廉江市": 334.0,
    "雷州市": 400.92,
    "吴川市": 906.9,
    "茂名市": 1414.76,
    "高州市": 298.78,
    "化州市": 263.01,
    "信宜市": 244.5,
    "肇庆市": 2672.42,
    "四会市": 390.0,
    "惠州市": 2684.11,
    "梅州市": 402.0,
    "兴宁市": 404.53,
    "汕尾市": 646.5,
    "陆丰市": 180.14,
    "河源市": 1278.34,
    "阳江市": 1695.0,
    "阳春市": 792.0,
    "清远市": 1611.59,
    "英德市": 321.07,
    "连州市": 144.79,
    "东莞市": 19427.55,
    "中山市": 1100.0,
    "潮州市": 864.74,
    "揭阳市": 1591.74,
    "普宁市": 479.62,
    "云浮市": 1592.43,
    "罗定市": 680.86,
    "广西": 19561.5,
    "南宁市": 3889.94,
    "柳州市": 2698.28,
    "桂林市": 2133.48,
    "荔浦市": 204.6,
    "梧州市": 513.68,
    "岑溪市": 175.45,
    "北海市": 1533.0,
    "防城港市": 518.56,
    "东兴市": 197.22,
    "钦州市": 1050.69,
    "贵港市": 1173.68,
    "桂平市": 191.46,
    "玉林市": 946.07,
    "北流市": 300.48,
    "百色市": 636.82,
    "靖西市": 123.27,
    "贺州市": 938.31,
    "河池市": 576.64,
    "来宾市": 1054.6,
    "合山市": 103.6,
    "崇左市": 336.47,
    "凭祥市": 265.2,
    "海南": 6812.03,
    "海口市": 1169.69,
    "三亚市": 1803.01,
    "三沙市": 9.98,
    "儋州市": 1462.03,
    "五指山市": 153.0,
    "琼海市": 971.0,
    "文昌市": 353.32,
    "万宁市": 665.0,
    "东方市": 225.0,
    "重庆": 19077.8,
    "重庆市": 19077.8,
    "四川": 42658.76,
    "成都市": 15471.56,
    "都江堰市": 489.99,
    "彭州市": 1076.34,
    "邛崃市": 266.8,
    "崇州市": 285.0,
    "简阳市": 263.75,
    "自贡市": 3098.58,
    "攀枝花市": 1224.37,
    "泸州市": 1967.96,
    "德阳市": 737.04,
    "广汉市": 296.9,
    "什邡市": 464.49,
    "绵竹市": 122.85,
    "绵阳市": 3954.43,
    "江油市": 686.0,
    "广元市": 584.0,
    "遂宁市": 1178.95,
    "内江市": 575.81,
    "隆昌市": 436.62,
    "乐山市": 1860.75,
    "峨眉山市": 207.0,
    "南充市": 1002.0,
    "阆中市": 253.0,
    "眉山市": 703.97,
    "宜宾市": 1540.75,
    "广安市": 718.82,
    "华蓥市": 217.79,
    "达州市": 759.5,
    "万源市": 76.99,
    "雅安市": 522.23,
    "巴中市": 319.22,
    "资阳市": 528.0,
    "马尔康市": 41.0,
    "康定市": 65.0,
    "西昌市": 661.3,
    "贵州": 16045.27,
    "贵阳市": 4894.14,
    "清镇市": 253.95,
    "六盘水市": 1585.06,
    "盘州市": 524.5,
    "遵义市": 3047.38,
    "赤水市": 180.0,
    "仁怀市": 679.93,
    "安顺市": 612.05,
    "毕节市": 581.3,
    "铜仁市": 466.0,
    "兴义市": 650.0,
    "兴仁市": 217.16,
    "凯里市": 1008.66,
    "都匀市": 1165.14,
    "福泉市": 180.0,
    "云南": 14297.96,
    "昆明市": 4583.66,
    "安宁市": 577.63,
    "曲靖市": 957.96,
    "宣威市": 158.2,
    "玉溪市": 472.25,
    "保山市": 415.81,
    "腾冲市": 218.0,
    "昭通市": 370.34,
    "丽江市": 656.49,
    "普洱市": 279.62,
    "临沧市": 251.37,
    "楚雄市": 678.08,
    "个旧市": 138.0,
    "开远市": 248.24,
    "蒙自市": 774.59,
    "弥勒市": 306.0,
    "文山市": 757.51,
    "景洪市": 254.4,
    "大理市": 343.65,
    "瑞丽市": 347.46,
    "芒市": 290.0,
    "泸水市": 1040.0,
    "香格里拉市": 178.7,
    "西藏": 1776.01,
    "拉萨市": 1047.41,
    "日喀则市": 350.6,
    "昌都市": 145.0,
    "林芝市": 100.0,
    "山南市": 27.0,
    "那曲市": 106.0,
    "陕西": 10233.84,
    "西安市": 4762.42,
    "铜川市": 437.01,
    "宝鸡市": 1178.59,
    "咸阳市": 665.6,
    "彬州市": 53.33,
    "兴平市": 59.75,
    "渭南市": 412.06,
    "韩城市": 363.0,
    "华阴市": 112.5,
    "延安市": 231.5,
    "汉中市": 472.96,
    "榆林市": 750.46,
    "神木市": 235.42,
    "安康市": 239.24,
    "商洛市": 132.0,
    "杨凌区": 128.0,
    "甘肃": 6007.51,
    "兰州市": 1578.66,
    "嘉峪关市": 428.9,
    "金昌市": 387.56,
    "白银市": 335.0,
    "天水市": 257.0,
    "武威市": 234.0,
    "张掖市": 445.5,
    "平凉市": 403.79,
    "华亭市": 39.2,
    "酒泉市": 331.49,
    "玉门市": 155.6,
    "敦煌市": 342.97,
    "庆阳市": 410.0,
    "定西市": 218.4,
    "陇南市": 70.0,
    "临夏市": 284.04,
    "合作市": 85.4,
    "青海": 2773.7,
    "西宁市": 1323.01,
    "海东市": 203.37,
    "玉树市": 339.0,
    "格尔木市": 610.11,
    "德令哈市": 298.21,
    "宁夏": 2783.15,
    "银川市": 801.41,
    "灵武市": 97.97,
    "宁东能源化工基地": 182.32,
    "石嘴山市": 587.0,
    "吴忠市": 311.7,
    "青铜峡市": 411.7,
    "固原市": 259.23,
    "中卫市": 131.82,
    "新疆": 11174.32,
    "乌鲁木齐市": 2268.0,
    "克拉玛依市": 1066.64,
    "吐鲁番市": 359.66,
    "哈密市": 827.94,
    "昌吉市": 481.88,
    "阜康市": 177.73,
    "博乐市": 321.23,
    "阿拉山口市": 201.49,
    "库尔勒市": 451.75,
    "阿克苏市": 380.0,
    "阿图什市": 75.25,
    "喀什市": 350.0,
    "和田市": 295.25,
    "伊宁市": 696.94,
    "奎屯市": 241.26,
    "霍尔果斯市": 158.0,
    "塔城市": 247.78,
    "乌苏市": 272.85,
    "阿勒泰市": 262.81,
    "石河子市": 584.12,
    "阿拉尔市": 114.0,
    "图木舒克市": 156.0,
    "五家渠市": 51.0,
    "北屯市": 188.14,
    "铁门关市": 158.23,
    "双河市": 50.0,
    "可克达拉市": 106.37,
    "昆玉市": 630.0
}